/* eslint-disable import/prefer-default-export */
import { ALWAYS_VISIBLE as CONSTANT } from '@sdk/components/Filters/Form.vue';

export const FILTERS = 'filters';
export const ALWAYS_VISIBLE = CONSTANT;
